<template>
  <el-dialog
    :title="$t('addAffiliateProduct.title')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('addAffiliateProduct.productId')" prop="productId">
        <el-input
          v-model="form.productId"
          :placeholder="$t('addAffiliateProduct.productIdPlaceholder')"
        />
        <div class="el-form-item__tip">{{ $t('addAffiliateProduct.productIdTip') }}</div>
      </el-form-item>
      <el-form-item :label="$t('addAffiliateProduct.seq')" prop="seq">
        <el-input
          v-model="form.seq"
          :placeholder="$t('addAffiliateProduct.seqPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveAffiliateProduct } from '@/api/affiliate/affiliateProductApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddAffiliateProduct',
  data() {
    return {
      dialogVisible: false,
      form: {
        productId: '',
        seq: '',
        shopId: ''
      },
      rules: {
        productId: [
          { required: true, message: this.$t('addAffiliateProduct.productIdRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('addAffiliateProduct.productIdMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('addAffiliateProduct.seqRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('addAffiliateProduct.seqPattern'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.form.shopId = getShopId()
          try {
            await saveAffiliateProduct(this.form)
            this.$message.success(this.$t('addAffiliateProduct.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.el-form-item__tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
</style>